<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-12 19:42:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-16 14:48:17
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\showDataAccessHeader.vue
-->
<template>
  <div class="d-flex align-center justify-space-between checkBox">
    <template v-if="!$store.state.uuid">
      <mrc_ess_switch true-value="1"
                      false-value="0"
                      :readonly="readonly"
                      v-model="num"
                      :label="label"></mrc_ess_switch>
      <mrc_ess_textAddBtn v-if="showAdd"
                          left
                          :textstatus='false'
                          color='white'
                          @click="addNewData"
                          :text="$t('label_New_data')">
      </mrc_ess_textAddBtn>
      <!-- <v-btn rounded
             v-if="showAdd"
             color="white"
             @click="addNewData"
             class="d-flex justify-center align-center px-5">
        <span style="color:#2658c7;font-size: 25px;line-height:25px;height:28px"
              class="mr-1">+</span><span style="font-size: 14px;color: rgba(0, 0, 0, 0.78);">
          {{$t('label_New_data')}}
        </span>
      </v-btn> -->

      <span v-else></span>
    </template>
    <template v-else>
      <v-checkbox v-model="num"
                  :disabled="readonly"
                  true-value="1"
                  false-value="0"
                  style="font-size: 20px;color: rgba(0, 0, 0, 0.38);"
                  :label="label"></v-checkbox>
      <!-- <v-btn rounded
             v-if="showAdd"
             color="white"
             @click="addNewData"
             class="d-flex justify-center align-center px-5">
        <span style="color:#2658c7;font-size: 25px;line-height:25px;height:28px"
              class="mr-1">+</span><span style="font-size: 14px;color: rgba(0, 0, 0, 0.78);">新数据</span>
      </v-btn> -->
      <mrc_ess_textAddBtn v-if="showAdd"
                          left
                          :textstatus='false'
                          color='white'
                          @click="addNewData"
                          :text="$t('label_New_data')"></mrc_ess_textAddBtn>
      <span v-else></span>
    </template>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    checkbox: {
      type: String,
      default: '0',
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'checkbox',
    event: 'change',
  },
  data () {
    return {
      num: 1,
    }
  },
  validations: {},
  computed: {},
  created () { },
  watch: {
    checkbox (val) {
      this.num = val
    },
    num (val) {
      this.$emit('change', val)
    },
  },
  mounted () {
    this.num = this.checkbox
  },
  methods: {
    addNewData () {
      this.$emit('add')
    },
  },
}
</script>

<style scoped>
.checkBox /deep/ .v-label {
  font-size: 20px;
  white-space: nowrap;
}
</style>
